/*!

=========================================================
* Vision UI Free Chakra - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-chakra
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-chakra/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// import
import Dashboard from "views/Dashboard/Dashboard.js";
import PR from "views/PR/PR";

import Tables from "views/Dashboard/Tables.js";
import Billing from "views/Dashboard/Billing.js";
import Profile from "views/Dashboard/Profile.js";
import SignIn from "views/Pages/SignIn.js";
import SignUp from "views/Pages/SignUp.js";

import {
  HomeIcon,
  PersonIcon,
  DocumentIcon,
  RocketIcon,
  AdvertiserIcon,
} from "components/Icons/Icons";

import Report from "views/PR/Report";

import CreateCampaign from "views/PR/Create";
import List from "views/PR/List";
import OrderList from "views/Order/List";
import OrderCreate from "views/Order/Create";
import PackageList from "views/Packages/List";
import CreatePackages from "views/Packages/Create";

// Icons
import { IoNewspaperOutline, IoCartOutline } from "react-icons/io5";
import { GoDotFill } from "react-icons/go";

// Images
import dashboardImage from "./assets/img/Dashboard.png";
import advertiserImage from "./assets/img/advertiser.png";
import orderImage from "./assets/img/Order.png";
import paymentImage from "./assets/img/payment.png";
import PRImage from "./assets/img/PR.png";

import CreateAdvertiser from "views/Advertiser/Create";
import AdvertiserList from "views/Advertiser/List";
import UpdatePackages from "views/Packages/Update";
import { MdPayment, MdUpdate } from "react-icons/md";
import UpdateCampaign from "views/PR/Update";
import PaymentList from "views/Payment/List";
import PaymentPay from "views/Payment/pay";
import PaymentPricing from "views/Payment/Pricing";
import PaymentDiscount from "views/Payment/Discount";

var userGroup = localStorage.getItem("group");

var dashRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: (
      <img
        src={dashboardImage}
        alt="Dashboard"
        style={{ width: 20, height: 20 }}
      />
    ),
    component: Dashboard,
    layout: "/publisher",
  },
  {
    name: "PR",
    icon: <img src={PRImage} alt="PR" style={{ width: 20, height: 20 }} />,
    layout: "/publisher",
    path: "/pr",
    list: [
      {
        path: "/pr/list",
        name: "List",
        icon: <GoDotFill color="inherit" />,
        component: List,
        layout: "/publisher",
      },
      // Conditionally hide this route if user group is publisher

      {
        path: "/pr/create",
        name: "Create",
        icon: <GoDotFill color="inherit" />,
        component: CreateCampaign,
        layout: "/publisher",
      },
      {
        path: "/pr/update",
        name: "Update",
        icon: <GoDotFill color="inherit" />,
        component: UpdateCampaign,
        layout: "/publisher",
      },

      {
        path: "/pr/report",
        name: "Report",
        icon: <GoDotFill color="inherit" />,
        component: Report,
        layout: "/publisher",
      },
    ],
  },

  {
    name: "Advertiser",
    icon: (
      <img
        src={advertiserImage}
        alt="Advertiser"
        style={{ width: 20, height: 20 }}
      />
    ),
    layout: "/publisher",
    path: "/advertiser",
    list: [
      {
        path: "/advertiser/list",
        name: "List",
        icon: <GoDotFill color="inherit" />,
        component: AdvertiserList,
        layout: "/publisher",
      },
      {
        path: "/advertiser/create",
        name: "Add",
        icon: <GoDotFill color="inherit" />,
        component: CreateAdvertiser,
        layout: "/publisher",
      },
    ],
  },

  // {
  //   name: "Packages",
  //   icon: <RocketIcon color="inherit" />,
  //   layout: "/publisher",
  //   path: "/packages",
  //   list: [
  //     {
  //       path: "/packages/list",
  //       name: "List",
  //       icon: <GoDotFill color="inherit" />,
  //       component: PackageList,
  //       layout: "/publisher",
  //     },

  //     {
  //       path: "/packages/create",
  //       name: "Add",
  //       icon: <GoDotFill color="inherit" />,
  //       component: CreatePackages,
  //       layout: "/publisher",
  //     },
  //     {
  //       path: "/packages/update",
  //       name: "Update",
  //       icon: <GoDotFill color="inherit" />,
  //       component: UpdatePackages,
  //       layout: "/publisher",
  //     },
  //   ],
  // },

  {
    name: "Order",
    icon: (
      <img src={orderImage} alt="Order" style={{ width: 20, height: 20 }} />
    ),
    layout: "/publisher",
    path: "/order",
    list: [
      {
        path: "/order/list",
        name: "List",
        icon: <GoDotFill color="inherit" />,
        component: OrderList,
        layout: "/publisher",
      },

      {
        path: "/order/create",
        name: "Create",
        icon: <GoDotFill color="inherit" />,
        component: OrderCreate,
        layout: "/publisher",
      },
    ],
  },
  {
    name: "Payment",
    icon: (
      <img src={paymentImage} alt="Payment" style={{ width: 20, height: 20 }} />
    ),
    layout: "/publisher",
    path: "/payment",
    list: [
      {
        path: "/payment/list",
        name: "List",
        icon: <GoDotFill color="inherit" />,
        component: PaymentList,
        layout: "/publisher",
      },

      {
        path: "/payment/pay",
        name: "Pay",
        icon: <GoDotFill color="inherit" />,
        component: PaymentPay,
        layout: "/publisher",
      },
      {
        path: "/payment/pricing",
        name: "Pricing",
        icon: <GoDotFill color="inherit" />,
        component: PaymentPricing,
        layout: "/publisher",
      },
      // {
      //   path: "/payment/discount",
      //   name: "Discount",
      //   icon: <GoDotFill color="inherit" />,
      //   component: PaymentDiscount,
      //   layout: "/publisher",
      // },
    ],
  },

  {
    name: "ACCOUNT PAGES",
    category: "account",
    state: "pageCollapse",
    views: [
      {
        path: "/profile",
        name: "Profile",
        icon: <PersonIcon color="inherit" />,
        secondaryNavbar: true,
        component: Profile,
        layout: "/publisher",
      },
      {
        path: "/signin",
        name: "Sign In",
        icon: <DocumentIcon color="inherit" />,
        component: SignIn,
        layout: "/auth",
      },
      {
        path: "/signup",
        name: "Sign Up",
        icon: <RocketIcon color="inherit" />,
        secondaryNavbar: true,
        component: SignUp,
        layout: "/auth",
      },
    ],
  },
];
var dashRoutes2 = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: (
      <img
        src={dashboardImage}
        alt="Dashboard"
        style={{ width: 20, height: 20 }}
      />
    ),
    component: Dashboard,
    layout: "/advertiser",
  },
  {
    name: "PR",
    icon: <img src={PRImage} alt="PR" style={{ width: 20, height: 20 }} />,
    layout: "/advertiser",
    path: "/pr",
    list: [
      {
        path: "/pr/list",
        name: "List",
        icon: <GoDotFill color="inherit" />,
        component: List,
        layout: "/advertiser",
      },
      // Conditionally hide this route if user group is publisher

      {
        path: "/pr/create",
        name: "Create",
        icon: <GoDotFill color="inherit" />,
        component: CreateCampaign,
        layout: "/advertiser",
      },
      {
        path: "/pr/update",
        name: "Update",
        icon: <MdUpdate color="inherit" />,
        component: UpdateCampaign,
        layout: "/advertiser",
      },

      {
        path: "/pr/report",
        name: "Report",
        icon: <GoDotFill color="inherit" />,
        component: Report,
        layout: "/advertiser",
      },
    ],
  },

  {
    name: "Packages",
    icon: <RocketIcon color="inherit" />,
    layout: "/advertiser",
    path: "/packages",
    list: [
      {
        path: "/packages/list",
        name: "List",
        icon: <GoDotFill color="inherit" />,
        component: PackageList,
        layout: "/advertiser",
      },
    ],
  },
  {
    name: "Order",
    icon: (
      <img src={orderImage} alt="Order" style={{ width: 20, height: 20 }} />
    ),
    layout: "/advertiser",
    path: "/order",
    list: [
      {
        path: "/order/list",
        name: "List",
        icon: <GoDotFill color="inherit" />,
        component: OrderList,
        layout: "/advertiser",
      },

      {
        path: "/order/create",
        name: "Create",
        icon: <GoDotFill color="inherit" />,
        component: OrderCreate,
        layout: "/advertiser",
      },
    ],
  },
  {
    name: "Payment",
    icon: (
      <img src={paymentImage} alt="Payment" style={{ width: 20, height: 20 }} />
    ),
    layout: "/advertiser",
    path: "/payment",
    list: [
      {
        path: "/payment/list",
        name: "List",
        icon: <GoDotFill color="inherit" />,
        component: PaymentList,
        layout: "/advertiser",
      },

      // {
      //   path: "/payment/pay",
      //   name: "Pay",
      //   icon: <GoDotFill color='inherit' />,
      //   component: PaymentPay,
      //   layout: "/advertiser",
      // },
    ],
  },
  {
    name: "ACCOUNT PAGES",
    category: "account",
    state: "pageCollapse",
    views: [
      {
        path: "/profile",
        name: "Profile",
        icon: <PersonIcon color="inherit" />,
        secondaryNavbar: true,
        component: Profile,
        layout: "/advertiser",
      },
      {
        path: "/signin",
        name: "Sign In",
        icon: <DocumentIcon color="inherit" />,
        component: SignIn,
        layout: "/auth",
      },
      {
        path: "/signup",
        name: "Sign Up",
        icon: <RocketIcon color="inherit" />,
        secondaryNavbar: true,
        component: SignUp,
        layout: "/auth",
      },
    ],
  },
];

export const accountroute = [
  {
    name: "ACCOUNT PAGES",
    category: "account",
    state: "pageCollapse",
    views: [
      {
        path: "/profile",
        name: "Profile",
        icon: <PersonIcon color="inherit" />,
        secondaryNavbar: true,
        component: Profile,
        layout: "/advertiser",
      },
      {
        path: "/signin",
        name: "Sign In",
        icon: <DocumentIcon color="inherit" />,
        component: SignIn,
        layout: "/auth",
      },
      {
        path: "/signup",
        name: "Sign Up",
        icon: <RocketIcon color="inherit" />,
        secondaryNavbar: true,
        component: SignUp,
        layout: "/auth",
      },
    ],
  },
];

export default { dashRoutes, dashRoutes2, accountroute };
